module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-board"
  }, [_vm._l((_vm.$store.getters.families), function(family, i) {
    return (_vm.showCategory(i)) ? _c('category', {
      key: ("" + family + i),
      attrs: {
        "title": _vm.capitalize(family) + 's'
      }
    }) : _vm._e()
  }), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.noAnimals()),
      expression: "noAnimals()"
    }],
    staticClass: "card-board__no-animals"
  }, [_vm._v("\n    There's no animals : (")])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ce652b5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CardBoard.vue
// module id = 24
// module chunks = 0